export default "__VITE_ASSET__CK4_7Fs2__"